
(() => {
  'use strict';
  const host = document.getElementById('ml-intro');
  if (host?.dataset?.introDesign === 'signature') return;
  const canvas = document.getElementById('intro-gold-flow');
  const scene = host?.querySelector('.intro-scene');
  if (!host || !canvas || !scene) return;
  let ctx;
  try { ctx = canvas.getContext('2d', { alpha: true }); } catch (_) { return; }
  if (!ctx) return;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const W = 1600, H = 900;
  const ROAD = [
    [[.994, .834], [.921, .823], [.833, .810], [.770, .786]],
    [[.770, .786], [.714, .769], [.741, .746], [.758, .722]],
    [[.758, .722], [.791, .675], [.708, .643], [.633, .622]],
    [[.633, .622], [.568, .602], [.448, .588], [.445, .549]],
    [[.445, .549], [.438, .516], [.554, .481], [.615, .447]]
  ];
  const ORBIT = [
    [[.615, .447], [.735, .403], [.891, .308], [.952, .202]],
    [[.952, .202], [.983, .156], [.984, .111], [.958, .104]],
    [[.958, .104], [.913, .085], [.841, .111], [.782, .145]],
    [[.782, .145], [.686, .216], [.607, .332], [.603, .413]],
    [[.603, .413], [.600, .435], [.602, .447], [.615, .447]]
  ];
  const CONTOURS = [
    [[[.315, .688], [.314, .527], [.314, .372], [.317, .275]],
     [[.317, .275], [.313, .201], [.337, .132], [.356, .108]],
     [[.356, .108], [.376, .086], [.398, .072], [.414, .060]]],
    [[[.279, .688], [.281, .445], [.280, .228], [.278, .002]]],
    [[[.089, .001], [.145, .091], [.218, .188], [.280, .257]]]
  ];

  function cubic(segment, t) {
    const k = 1 - t;
    const x = (k*k*k*segment[0][0] + 3*k*k*t*segment[1][0] + 3*k*t*t*segment[2][0] + t*t*t*segment[3][0]) * W;
    const y = (k*k*k*segment[0][1] + 3*k*k*t*segment[1][1] + 3*k*t*t*segment[2][1] + t*t*t*segment[3][1]) * H;
    return { x, y };
  }
  function makeTrack(curves) {
    const points = [], STEPS = 96;
    let length = 0, previous;
    curves.forEach((curve, segment) => {
      for (let i = segment ? 1 : 0; i <= STEPS; i++) {
        const p = cubic(curve, i / STEPS);
        if (previous) length += Math.hypot(p.x - previous.x, p.y - previous.y);
        points.push({ ...p, distance: length, segment });
        previous = p;
      }
    });
    return { points, length };
  }
  const road = makeTrack(ROAD), orbit = makeTrack(ORBIT), contours = CONTOURS.map(makeTrack);
  function sample(track, progress) {
    const distance = Math.max(0, Math.min(1, progress)) * track.length;
    let lo = 0, hi = track.points.length - 1;
    while (hi - lo > 1) {
      const mid = (lo + hi) >>> 1;
      if (track.points[mid].distance < distance) lo = mid; else hi = mid;
    }
    const a = track.points[lo], b = track.points[hi];
    const t = (distance - a.distance) / Math.max(.0001, b.distance - a.distance);
    const dx = b.x - a.x, dy = b.y - a.y, len = Math.max(.001, Math.hypot(dx, dy));
    return { x: a.x + dx*t, y: a.y + dy*t, nx: -dy/len, ny: dx/len, segment: b.segment };
  }
  const fract = value => value - Math.floor(value);
  const envelope = t => Math.min(1, t * 16, (1 - t) * 16);
  let seed = 451;
  function random() {
    seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
    return seed / 4294967296;
  }
  const state = { running: false, raf: 0, time: 0, lastTick: null, lastPaint: -Infinity,
    width: 0, height: 0, dpr: 1, mobile: false, frames: 0, particles: [], strands: [], disposed: false };
  function buildParticles() {
    seed = 451;
    state.particles = [];
    const add = (kind, count) => {
      for (let i = 0; i < count; i++) state.particles.push({
        kind, phase: random(), lane: random()*2 - 1, radius: .6 + random()*1.35,
        alpha: .25 + random()*.42, speed: kind === 'road' ? .029 + random()*.033 : kind === 'orbit' ? .010 + random()*.011 : .008 + random()*.009,
        drift: random()*Math.PI*2, contour: i % contours.length
      });
    };
    add('road', state.mobile ? 92 : 168);
    add('orbit', state.mobile ? 36 : 74);
    add('contour', state.mobile ? 18 : 34);
    state.strands = Array.from({ length: state.mobile ? 10 : 17 }, () => ({
      phase: random(), lane: random()*2-1, speed: .029 + random()*.021,
      tail: .015 + random()*.031, alpha: .37 + random()*.22
    }));
  }
  function position(token, freeSpace) {
    if (token?.endsWith('%')) return parseFloat(token)/100 * freeSpace;
    if (token === 'left' || token === 'top') return 0;
    if (token === 'right' || token === 'bottom') return freeSpace;
    if (!token || token === 'center') return freeSpace/2;
    return Number.parseFloat(token) || 0;
  }
  function matrix(text) {
    if (!text || text === 'none') return [1,0,0,1,0,0];
    const values = text.slice(text.indexOf('(')+1, -1).split(',').map(Number);
    if (values.length === 6 && values.every(Number.isFinite)) return values;
    if (values.length === 16 && values.every(Number.isFinite)) return [values[0],values[1],values[4],values[5],values[12],values[13]];
    return [1,0,0,1,0,0];
  }
  function imageTransform() {
    const style = window.getComputedStyle(scene), width = state.width, height = state.height;
    const iw = scene.naturalWidth || W, ih = scene.naturalHeight || H;
    const cover = Math.max(width/iw, height/ih);
    const dw = iw*cover, dh = ih*cover;
    const pos = style.objectPosition.split(/\s+/);
    const ox = position(pos[0], width-dw), oy = position(pos[1], height-dh);
    const origin = style.transformOrigin.split(/\s+/);
    const tx = origin[0]?.endsWith('%') ? parseFloat(origin[0])*width/100 : parseFloat(origin[0]) || 0;
    const ty = origin[1]?.endsWith('%') ? parseFloat(origin[1])*height/100 : parseFloat(origin[1]) || 0;
    const [a,b,c,d,e,f] = matrix(style.transform), ratio = state.dpr;
    return [ratio*a*dw/W, ratio*b*dw/W, ratio*c*dh/H, ratio*d*dh/H,
      ratio*(a*ox+c*oy+e+tx-a*tx-c*ty), ratio*(b*ox+d*oy+f+ty-b*tx-d*ty)];
  }
  function resize() {
    if (host.hidden || state.disposed) return;
    const rect = host.getBoundingClientRect();
    const width = Math.max(1, rect.width), height = Math.max(1, rect.height);
    const mobile = width <= 700;
    const dpr = Math.min(2, Number(window.devicePixelRatio) || 1);
    if (width === state.width && height === state.height && dpr === state.dpr && mobile === state.mobile) return;
    state.width = width; state.height = height; state.dpr = dpr; state.mobile = mobile;
    canvas.width = Math.round(width*dpr); canvas.height = Math.round(height*dpr);
    buildParticles();
    if (state.running) paint();
  }
  function roadPoint(t, lane, drift = 0) {
    const p = sample(road, t);
    const width = 8 + 35*(1-t)*(1-t);
    const offset = lane*width + drift;
    return { x: p.x+p.nx*offset, y: p.y+p.ny*offset };
  }
  function glow(x, y, radius, alpha, wide = false) {
    ctx.globalAlpha = alpha;
    ctx.fillStyle = '#fff0b6';
    ctx.beginPath(); ctx.arc(x, y, radius, 0, Math.PI*2); ctx.fill();
    ctx.globalAlpha = alpha*.16;
    ctx.fillStyle = '#e5ad43';
    ctx.beginPath(); ctx.arc(x, y, radius*(wide ? 4.8 : 3.1), 0, Math.PI*2); ctx.fill();
  }
  function paint() {
    ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,canvas.width,canvas.height);
    ctx.setTransform(...imageTransform()); ctx.globalCompositeOperation = 'lighter';
    const time = state.time;
    state.strands.forEach(strand => {
      const head = fract(strand.phase+time*strand.speed);
      for (let j = 0; j < 15; j++) {
        const t0 = head-strand.tail*j/15, t1 = head-strand.tail*(j+1)/15;
        if (t1 < 0) continue;
        const p = roadPoint(t0,strand.lane), q = roadPoint(t1,strand.lane);
        const alpha = strand.alpha*(1-j/15)*envelope(t0);
        ctx.globalAlpha = alpha*.16; ctx.strokeStyle = '#e5a83e'; ctx.lineWidth = 7*(1-t0)+2;
        ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(q.x,q.y);ctx.stroke();
        ctx.globalAlpha = alpha;ctx.strokeStyle = '#fff0b1';ctx.lineWidth = 1.3+(1-t0)*1.5;
        ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(q.x,q.y);ctx.stroke();
      }
    });
    state.particles.forEach(particle => {
      const t = fract(particle.phase+time*particle.speed);
      let p, alpha = particle.alpha, radius = particle.radius;
      if (particle.kind === 'road') {
        p = roadPoint(t,particle.lane,Math.sin(time*.24+particle.drift)*2);
        alpha *= envelope(t); radius *= .64+(1-t)*.6;
      } else if (particle.kind === 'orbit') {
        p = sample(orbit,t);
        const globe = ((p.x/W-.793)/.194)**2 + ((p.y/H-.375)/.267)**2;
        if (p.segment >= 2 && globe < 1.025) return;
        const offset = particle.lane*3.7+Math.sin(time*.16+particle.drift)*1.7;
        p = { x:p.x+p.nx*offset, y:p.y+p.ny*offset };
        if (p.segment >= 2) alpha *= .52;
        radius *= .84;
      } else {
        const point = sample(contours[particle.contour],t);
        const offset = particle.lane*3.2+Math.sin(time*.21+particle.drift)*4.1;
        p = { x:point.x+point.nx*offset, y:point.y+point.ny*offset };
        alpha *= envelope(t)*.72; radius *= .8;
      }
      glow(p.x,p.y,radius,alpha,particle.kind === 'road');
    });
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over'; state.frames++;
  }
  function canRun() {
    return !state.disposed && !host.hidden && host.classList.contains('intro-running') &&
      !host.classList.contains('intro-leaving') && !document.hidden && !motion.matches;
  }
  function stop(clear = false) {
    if (state.raf) window.cancelAnimationFrame(state.raf);
    state.raf = 0; state.running = false; state.lastTick = null; state.lastPaint = -Infinity;
    if (clear) { ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,canvas.width,canvas.height); }
  }
  function tick(timestamp) {
    state.raf = 0;
    if (!canRun()) { stop(host.hidden || motion.matches); return; }
    if (state.lastTick !== null) state.time += Math.min(.08,Math.max(0,(timestamp-state.lastTick)/1000));
    state.lastTick = timestamp;
    const interval = 1000/(state.mobile ? 30 : 60);
    if (timestamp-state.lastPaint >= interval-.5) { paint();state.lastPaint=timestamp; }
    state.raf = window.requestAnimationFrame(tick);
  }
  function sync() {
    if (!canRun()) { stop(host.hidden || motion.matches); return; }
    resize();
    if (!state.running) { state.running=true;state.raf=window.requestAnimationFrame(tick); }
  }
  const observer = new MutationObserver(sync);
  observer.observe(host,{attributes:true,attributeFilter:['hidden','class']});
  document.addEventListener('visibilitychange',sync);
  window.addEventListener('resize',resize);
  const onSceneLoad = () => { if (state.running) paint(); };
  scene.addEventListener('load',onSceneLoad);
  if (motion.addEventListener) motion.addEventListener('change',sync); else motion.addListener(sync);
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(resize) : null;
  resizeObserver?.observe(host);
  window.MLIntroGoldMotion = Object.freeze({
    getState:()=>({running:state.running,pendingFrame:!!state.raf,frames:state.frames,dpr:state.dpr,
      width:state.width,height:state.height,fps:state.mobile?30:60,particles:state.particles.length,
      roadLength:road.length,orbitLength:orbit.length,alignment:imageTransform()}),
    dispose:()=>{state.disposed=true;stop(true);observer.disconnect();resizeObserver?.disconnect();
      document.removeEventListener('visibilitychange',sync);window.removeEventListener('resize',resize);
      scene.removeEventListener('load',onSceneLoad);
      if(motion.removeEventListener)motion.removeEventListener('change',sync);else motion.removeListener(sync);}
  });
  sync();
})();
